import { graphql, compose } from 'react-apollo';
import { queryContactsByAtsIdIndex } from 'src/_shared/api/graphql/custom/contacts/contactsByAtsIdGraphql';

export const withListContactsByAtsId = (Component, variables) => {
	return compose(
		graphql(queryContactsByAtsIdIndex, {
			options: (props) => ({
				context: {
					headers: {
						'x-frame-options': 'deny', // This header will reach the server
					},
				},
				variables: {
					atsId: props?.currentUser?.accountClaim?.atsId,
					first: 50,
					after: '',
				},
				fetchPolicy: 'network-only',
				skip: !props?.currentUser?.accountClaim?.atsId,
			}),
			props: (props) => ({
				matchingAtsIdContacts: props?.data?.queryContactsByAtsIdIndex
					? data.queryContactsByAtsIdIndex.items
					: [],
			}),
		})
	)(Component);
};
